import { LoadingSpinner } from '@neo4j-ndl/react';
import { Center } from '@nx/ui';
import { Suspense, lazy } from 'react';

const ConversationsApp = lazy(() => import('@nx/conversations/src/upx-main'));

export const AgentsLayout = () => {
  return (
    <Suspense
      fallback={
        <Center>
          <LoadingSpinner className="m-auto" size="large" />
        </Center>
      }
    >
      <ConversationsApp />
    </Suspense>
  );
};
